import React from 'react'
import Select from 'react-select/creatable'
import Label from './Input/Label'
import * as Str from './String'
import getStyles from './Select/styles.js'

export class Input extends React.Component {
  onChange = (v) => {
    let { onChange, onValueChange } = this.props
    onChange && onChange(v)
    onValueChange && onValueChange(v && v.value)
  }

  onKeyDown = (e) => {
    if (e.keyCode === 13 && this.select && this.select.select && this.select.select.menuListRef) {
      e.stopPropagation()
    }
  }

  getRef = ref => this.select = ref

  render () {
    let props = this.props
    let value = props.data || props.value
    let options = props.picklist || props.options || []

    if (typeof options === 'object' && !Array.isArray(options)) {
      options = Object.keys(options).map(k => ({ value: k, label: options[k] }))
    }

    const selValue = value && options.find(o => o.value === value)
    return (
      <div className={`w-100`}>
        <Label {...props} />
        <Select
          ref={this.getRef}
          onKeyDown={this.onKeyDown}
          {...props}
          value={selValue || null}
          className={`input ${(this.props.required && !selValue && 'is-invalid') || ''}`}
          options={options || []}
          onChange={this.onChange}
          isClearable
          hasValue={!!selValue}
          menuPortalTarget={document.body}
          components={{
            ...props.components,
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null
          }}
          placeholder={this.props.placeholder}
          styles={getStyles(this.props)}
          classNamePrefix={'react-select'}
          menuPlacement={props.menuPlacement || 'auto'}
          blurInputOnSelect
        />
      </div>
    )
  }
}

export const Output = Str.Output
